import { useLayoutEffect } from 'react';

export const PINNED_ATTR = 'data-page-pinned';

let pins = 0;

// A target just above the top: iOS 26 can drop scrollTo(0, 0) near a sticky element (WebKit bug 304489, found on OdeParfum)
const goToTop = () => window.scrollTo({ top: -1, left: 0, behavior: 'auto' });

/**
 * A full-screen fixed layer (the installed app's welcome) owns the viewport: the window goes to the top before the
 * first paint and can't scroll behind it.
 *
 * The lock is one attribute on <html> and a rule in src/styles/pwa.css, never inline overflow: the UI library's modals
 * save and restore inline overflow too, a transition later, so the two restore each other's values. On OdeParfum, the
 * welcome saved the closing menu's "hidden" and put it back after the login: the whole app stopped scrolling (owner
 * report 30/10/2026).
 */
export const usePinnedPage = (active = true) => {
  useLayoutEffect(() => {
    if (!active) return undefined;
    const html = document.documentElement;
    goToTop();
    pins += 1;
    html.setAttribute(PINNED_ATTR, '');
    const onScroll = () => {
      // > 0, not !== 0: iOS reports -1 for a moment after going to the top, then settles on 0
      if (window.scrollY > 0) goToTop();
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', onScroll);
      pins -= 1;
      if (pins === 0) html.removeAttribute(PINNED_ATTR);
    };
  }, [active]);
};
